import { BORDER_RADIUSES } from 'shared/styles/variables';
import styled from 'styled-components';

import Button from 'design-system/components/Button';
import Card from 'design-system/components/Card';
import { Elevation } from 'design-system/variables/effect';

const StyledCard = styled(Card)`
  width: fit-content;
  text-align: center;
  min-width: 200px;
  border-radius: ${BORDER_RADIUSES.rounded};
  box-shadow: ${Elevation.Mid};
  user-select: none;
`;

interface GraphProgressiveLoadingBoxProps {
  handleLoadMoreResults: () => void;
  nodeLimit: number;
}

const GraphProgressiveLoadingBox = ({
  handleLoadMoreResults,
  nodeLimit,
}: GraphProgressiveLoadingBoxProps) => {
  return (
    <StyledCard>
      <Card.Body>
        {nodeLimit} nodes loaded.
        <Button id='graph-explorer__load-more-button' onClick={handleLoadMoreResults}>
          Load More
        </Button>
      </Card.Body>
    </StyledCard>
  );
};

export default GraphProgressiveLoadingBox;
